import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PorteurService } from "../porteur.service";
import { Cab } from "./cab";

@Injectable({
  providedIn: 'root'
})
export class CabResolver {
  constructor(
    private porteurService: PorteurService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Cab> {
    return this.porteurService.getCab(route.parent.parent.params['numPorteur'], route.params['code_article'], route.params['taille']);
  }

}
